/**
 * Returns whether a feature is enabled for the current session.
 *
 * @param {IReduxState} state - The Redux state.
 * @param {string} feature - The feature key.
 * @returns {boolean}
 */
export function isFeatureEnabledForSession(state, feature) {
    return state['features/feature-controls']?.[feature] !== false;
}
